<template>
  <div class="renderPage cli-container" :class="{ 'theme--dark': $vuetify.theme.dark }">

    <!-- TOOLBAR CABECERA -->
    <v-toolbar flat height="56" :color="$vuetify.theme.dark ? '#1e293b' : '#f1f5f9'" class="cli-toolbar px-2">
      <v-icon class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-account-group-outline</v-icon>
      <v-toolbar-title class="font-weight-black text-uppercase cli-toolbar-title" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-4'">
        Gestión de Clientes
      </v-toolbar-title>
      <v-spacer />
      <v-btn depressed color="primary" class="cli-btn font-weight-bold" @click="incluir()">
        <v-icon left small>mdi-plus</v-icon> Nuevo Cliente
      </v-btn>
    </v-toolbar>

    <!-- TABLA -->
    <v-card flat class="cli-table-card mx-0" :color="$vuetify.theme.dark ? '#0f172a' : 'white'">
      <v-toolbar flat height="52" :color="$vuetify.theme.dark ? '#0f172a' : 'white'" class="px-3">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar por nombre, cédula o código..."
          single-line hide-details outlined dense
          class="cli-search"
          style="max-width:420px"
        ></v-text-field>
        <v-spacer />
        <v-btn icon :color="$vuetify.theme.dark ? 'blue-grey lighten-2' : 'grey darken-1'" @click="getData()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="cli-table"
        :items-per-page="25"
        :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
        @click:row="editItem"
        style="cursor:pointer"
      >
        <template v-slot:[`item.codigo`]="{ item }">
          <span class="cli-code-badge">{{ item.codigo }}</span>
        </template>

        <template v-slot:[`item.nombre`]="{ item }">
          <div class="d-flex flex-column py-1">
            <span class="font-weight-bold text-body-2">{{ item.nombre }}</span>
            <span class="caption" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">{{ item.nombreComercial }}</span>
          </div>
        </template>

        <template v-slot:[`item.cedula`]="{ item }">
          <span class="font-weight-medium text-body-2">{{ item.cedula }}</span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn color="blue-grey darken-2" depressed dark style="min-width:36px;height:36px;padding:0;border-radius:4px" @click.stop="editItem(item)">
            <v-icon size="18">mdi-pencil-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:no-data>
          <div class="pa-8 text-center">
            <v-icon size="48" :color="$vuetify.theme.dark ? 'blue-grey darken-1' : 'grey lighten-1'" class="mb-3">mdi-account-search-outline</v-icon>
            <p :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">No se encontraron clientes.</p>
            <v-btn color="primary" depressed small @click="getData()">Reintentar</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- DRAWER FORMULARIO -->
    <v-navigation-drawer v-model="drawerForm" fixed right temporary width="600" class="cli-drawer">
      <div class="d-flex flex-column fill-height">

        <!-- HEADER DRAWER -->
        <div class="cli-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'cli-drawer-header--dark' : ''">
          <v-icon color="white" class="mr-3">{{ editedIndex > -1 ? 'mdi-account-edit' : 'mdi-account-plus' }}</v-icon>
          <div>
            <div class="white--text font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.95rem;">
              {{ editedIndex > -1 ? 'Editar Cliente' : 'Nuevo Cliente' }}
            </div>
            <div class="caption white--text" style="opacity:0.7">{{ editedItem.codigo || 'SIN CÓDIGO' }} · Información fiscal y de contacto</div>
          </div>
          <v-spacer />
          <v-btn icon dark small @click="cerrar()"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <!-- FORMULARIO -->
        <div class="flex-grow-1 overflow-y-auto pa-5">
          <v-form ref="form" v-model="valid">

            <!-- DATOS GENERALES -->
            <div class="cli-section-label mb-3">
              <v-icon small class="mr-1" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-account-outline</v-icon>
              <span class="font-weight-black text-caption text-uppercase" style="letter-spacing:1px" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Datos Generales</span>
            </div>
            <v-card flat class="cli-section-card pa-4 mb-4">
              <v-row dense>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="editedItem.codigo"
                    label="Código"
                    outlined dense readonly
                    prepend-inner-icon="mdi-identifier"
                    class="cli-readonly-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-select
                    v-model="editedItem.tipoId"
                    :items="tiposIdentificacion"
                    item-text="descripcion"
                    item-value="tipoId"
                    label="Tipo Identificación"
                    outlined dense
                    prepend-inner-icon="mdi-card-account-mail-outline"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-text-field
                    v-model="editedItem.cedula"
                    label="Identificación"
                    outlined dense type="number"
                    prepend-inner-icon="mdi-account-details-outline"
                    autocomplete="off"
                    @change="changeValueComponent"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-btn color="primary" block depressed height="40" class="cli-btn font-weight-bold" @click="getClienteHacienda">
                    <v-icon left size="16">mdi-file-find</v-icon> Hacienda
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.nombre"
                    label="Nombre o Razón Social"
                    outlined dense
                    prepend-inner-icon="mdi-office-building-outline"
                    autocomplete="off"
                    :rules="nameRules" required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.nombreComercial"
                    label="Nombre Comercial"
                    outlined dense
                    prepend-inner-icon="mdi-tag-outline"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="editedItem.moneda"
                    :items="monedas"
                    item-text="md_nombre"
                    item-value="md_codigo"
                    label="Moneda"
                    outlined dense
                    prepend-inner-icon="mdi-cash"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" class="d-flex align-center">
                  <v-checkbox
                    v-model="editedItem.esReceptor"
                    label="Es Receptor de Hacienda"
                    class="mt-1"
                    color="primary"
                    @click="changeEsReceptor"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.correo"
                    label="Correo Electrónico"
                    outlined dense
                    prepend-inner-icon="mdi-email-outline"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>

            <!-- EXPANSIÓN: UBICACIÓN -->
            <v-expansion-panels flat class="cli-panels mb-2" v-model="panels">
              <v-expansion-panel class="cli-expansion-panel mb-2">
                <v-expansion-panel-header class="font-weight-bold text-caption text-uppercase" style="letter-spacing:1px;min-height:48px">
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-map-marker-radius-outline</v-icon>
                    <span :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Ubicación y Contacto</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense class="pt-2">
                    <v-col cols="6">
                      <v-autocomplete v-model="editedItem.provincia" :items="provincias" item-text="pr_nombre" item-value="pr_codigo" label="Provincia" outlined dense clearable @change="changeProvincia"></v-autocomplete>
                    </v-col>
                    <v-col cols="6">
                      <v-autocomplete v-model="editedItem.canton" :items="cantones" item-text="ct_nombre" item-value="ct_codigo" label="Cantón" outlined dense clearable :disabled="!editedItem.provincia" @change="changeCantones"></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete v-model="editedItem.distrito" :items="distritos" item-text="dt_nombre" item-value="dt_codigo" label="Distrito" outlined dense clearable :disabled="!editedItem.canton" @change="changeDistritos"></v-autocomplete>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field v-model="editedItem.areaTel" label="Área" outlined dense type="number"></v-text-field>
                    </v-col>
                    <v-col cols="8">
                      <v-text-field v-model="editedItem.telefono" label="Teléfono" outlined dense type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea v-model="editedItem.direccion" label="Dirección Exacta" outlined dense rows="2"></v-textarea>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- EXPANSIÓN: ACTIVIDADES ECONÓMICAS -->
              <v-expansion-panel class="cli-expansion-panel mb-2">
                <v-expansion-panel-header class="font-weight-bold text-caption text-uppercase" style="letter-spacing:1px;min-height:48px">
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-briefcase-outline</v-icon>
                    <span :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Actividades Económicas</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-simple-table dense v-if="actividades.length > 0" class="cli-simple-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Código</th>
                          <th>Descripción</th>
                          <th>Estado</th>
                          <th class="text-center">Defecto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="act in actividades" :key="act.codigo">
                          <td><span class="cli-code-badge">{{ act.codigo }}</span></td>
                          <td>{{ act.descripcion }}</td>
                          <td>{{ act.estado }}</td>
                          <td class="text-center">
                            <v-radio-group v-model="actividadDefecto" hide-details dense class="mt-0 pt-0">
                              <v-radio :value="act.codigo" color="primary" @change="marcarDefecto(act)"></v-radio>
                            </v-radio-group>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <p v-else class="caption text-center pa-2" :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">
                    Usa el botón <strong>Hacienda</strong> para cargar las actividades automáticamente.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- EXPANSIÓN: EXONERACIÓN -->
              <v-expansion-panel class="cli-expansion-panel">
                <v-expansion-panel-header class="font-weight-bold text-caption text-uppercase" style="letter-spacing:1px;min-height:48px">
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-percent-outline</v-icon>
                    <span :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Configuración de Exoneración</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-checkbox
                    v-model="editedItem.esExonerado"
                    label="¿Este cliente cuenta con exoneración?"
                    color="primary"
                    @click="changeEsExonerado"
                  ></v-checkbox>
                  <v-row dense v-if="esExo">
                    <v-col cols="12">
                      <v-select v-model="editedItem.exoTipo" :items="tiposExoneraciones" item-text="descripcion" item-value="codigo" label="Tipo de Exoneración" outlined dense></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="editedItem.exoNumDocumento" label="N° Documento" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="editedItem.exoPorcentaje" label="Porcentaje %" outlined dense type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="editedItem.exoNomInstitucion" label="Institución que exonera" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-dialog ref="dialogExo" v-model="modalFecha" :return-value.sync="editedItem.exoFecha" width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="editedItem.exoFecha" label="Fecha Emisión" prepend-inner-icon="mdi-calendar" readonly outlined dense v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="editedItem.exoFecha" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modalFecha = false">Cancelar</v-btn>
                          <v-btn text color="primary" @click="$refs.dialogExo.save(editedItem.exoFecha)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                  </v-row>
                  <p v-else class="caption text-center pa-2" :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">
                    Active la casilla si el cliente tiene documentos de exoneración aprobados.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </v-form>
        </div>

        <!-- FOOTER ACCIONES -->
        <div class="cli-drawer-footer d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'cli-drawer-footer--dark' : ''">
          <v-btn v-if="editedIndex > -1" color="error" text class="cli-btn font-weight-bold" @click="deleteItem()">
            <v-icon left small>mdi-trash-can-outline</v-icon> Eliminar
          </v-btn>
          <v-spacer />
          <v-btn text class="mr-3 font-weight-bold cli-btn" @click="cerrar()">Cancelar</v-btn>
          <v-btn color="primary" depressed class="px-8 font-weight-bold cli-btn" :loading="loading" @click="save()">
            {{ editedIndex > -1 ? 'GUARDAR' : 'CREAR CLIENTE' }}
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";

export default {
  components: {
    Snackbar,
  },
  data() {
    return {
      drawerForm: false,
      loading: false,
      valid: false,
      panels: undefined,
      modalFecha: false,
      search: "",
      snackText: "",
      snackValue: false,
      esRec: false,
      esExo: false,
      actividades: [],
      actividadDefecto: null,
      headers: [
        { text: "Código", value: "codigo", sortable: true },
        { text: "Nombre / Comercial", value: "nombre", sortable: true },
        { text: "Identificación", value: "cedula", sortable: true },
        { text: "Acciones", value: "actions", align: 'right', sortable: false },
      ],
      items: [],
      tiposIdentificacion: [],
      tiposExoneraciones: [],
      monedas: [],
      provincias: [],
      cantones: [],
      distritos: [],
      editedIndex: -1,
      editedItem: {
        codigo: "",
        nombre: "",
        moneda: "CRC",
        provincia: "",
        canton: "",
        distrito: "",
        barrio: "",
        direccion: "",
        esReceptor: false,
        correo: "",
        tipoId: "",
        nombreComercial: "",
        areaTel: "",
        telefono: "",
        cedula: "",
        cia: "",
        esExonerado: false,
        exoTipo: "",
        exoNumDocumento: "",
        exoNomInstitucion: "",
        exoFecha: new Date().toISOString().substr(0, 10),
        exoPorcentaje: 0,
      },
      defaultItem: {
        codigo: "",
        nombre: "",
        moneda: "CRC",
        provincia: "",
        canton: "",
        distrito: "",
        barrio: "",
        direccion: "",
        esReceptor: false,
        correo: "",
        tipoId: "",
        nombreComercial: "",
        areaTel: "506",
        telefono: "88888888",
        cedula: "",
        cia: "",
        esExonerado: false,
        exoTipo: "",
        exoNumDocumento: "",
        exoNomInstitucion: "",
        exoFecha: new Date().toISOString().substr(0, 10),
        exoPorcentaje: 0,
      },
      nameRules: [(v) => !!v || "El nombre es requerido"],
    };
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
  },

  created() {
    this.getData();
    this.getTiposIdentificacion();
    this.getTiposExoneracion();
    this.getMonedas();
    this.getProvincias();
  },

  methods: {
    getData() {
      let me = this;
      axios.get("api/Clientes/getClientesByCompany?cia=" + this.strCia)
        .then(response => { me.items = response.data; })
        .catch(err => console.error(err));
    },

    getTiposIdentificacion() {
      let me = this;
      axios.get("api/General/getTiposIdentificacion").then(res => { me.tiposIdentificacion = res.data; });
    },

    getTiposExoneracion() {
      let me = this;
      axios.get("api/General/getTipoExoneraciones").then(res => { me.tiposExoneraciones = res.data; });
    },

    getMonedas() {
      let me = this;
      axios.get("api/General/getMonedas").then(res => { me.monedas = res.data; });
    },

    getProvincias() {
      let me = this;
      axios.get("api/General/getProvincias").then(res => { me.provincias = res.data; });
    },

    getCantones() {
      let me = this;
      axios.get("api/General/getCantones?provincia=" + this.editedItem.provincia).then(res => { me.cantones = res.data; });
    },

    getDistritos() {
      let me = this;
      axios.get("api/General/getDistritos?provincia=" + this.editedItem.provincia + "&canton=" + this.editedItem.canton).then(res => { me.distritos = res.data; });
    },

    changeProvincia() { this.editedItem.canton = ""; this.editedItem.distrito = ""; this.editedItem.direccion = ""; this.getCantones(); },
    changeCantones() { this.editedItem.distrito = ""; this.editedItem.direccion = ""; this.getDistritos(); },
    changeDistritos() { this.actualizarDireccionUbicacion(); },

    actualizarDireccionUbicacion() {
      const prov = this.provincias.find(p => p.pr_codigo === this.editedItem.provincia);
      const cant = this.cantones.find(c => c.ct_codigo === this.editedItem.canton);
      const dist = this.distritos.find(d => d.dt_codigo === this.editedItem.distrito);
      const partes = [prov && prov.pr_nombre, cant && cant.ct_nombre, dist && dist.dt_nombre].filter(Boolean);
      if (partes.length) this.editedItem.direccion = partes.join(", ");
    },

    getClienteHacienda() {
      if (!this.editedItem.cedula) return;
      let me = this;
      axios.get("https://api.hacienda.go.cr/fe/ae?identificacion=" + me.editedItem.cedula).then(res => {
        const d = res.data;
        me.editedItem.nombre = d.nombre || me.editedItem.nombre;
        me.editedItem.nombreComercial = d.nombre || me.editedItem.nombreComercial;
        if (d.tipoIdentificacion) me.editedItem.tipoId = d.tipoIdentificacion;
        if (d.situacion && d.situacion.estado && d.situacion.estado.toLowerCase().includes("inscrito")) {
          me.editedItem.esReceptor = true;
          me.esRec = true;
          me.editedItem.areaTel = "506";
          if (!me.editedItem.telefono) me.editedItem.telefono = "88888888";
          me.panels = 0;
        }
        if (d.actividades && d.actividades.length > 0) {
          me.actividades = d.actividades.map((a, i) => ({
            codigo: a.codigo,
            descripcion: a.descripcion,
            estado: a.estado || "Activo",
            esDefecto: i === 0,
          }));
          me.actividadDefecto = me.actividades[0].codigo;
        }
      });
    },

    getActividadesByCliente() {
      if (!this.editedItem.cedula || !this.strCia) return;
      let me = this;
      axios.get("api/Clientes/getActividadesByCliente?cedulaCia=" + this.strCia + "&cedulaCliente=" + this.editedItem.cedula)
        .then(res => {
          if (res.data && res.data.length > 0) {
            me.actividades = res.data;
            const def = res.data.find(a => a.esDefecto);
            me.actividadDefecto = def ? def.codigo : res.data[0].codigo;
          }
        })
        .catch(err => console.error(err));
    },

    marcarDefecto(act) {
      this.actividades.forEach(a => { a.esDefecto = a.codigo === act.codigo; });
    },

    changeEsReceptor() {
      this.esRec = this.editedItem.esReceptor;
      if (this.editedItem.esReceptor) {
        if (!this.editedItem.telefono) this.editedItem.telefono = "88888888";
        this.panels = 0;
      }
    },
    changeEsExonerado() { this.esExo = this.editedItem.esExonerado; },
    changeValueComponent() { /* Logic for validation/tracking */ },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.esRec = this.editedItem.esReceptor;
      this.esExo = this.editedItem.esExonerado;
      this.panels = this.editedItem.esReceptor ? 0 : undefined;
      this.actividades = [];
      this.actividadDefecto = null;

      if (this.editedItem.provincia) {
        this.getCantones();
        if (this.editedItem.canton) {
          this.getDistritos();
        }
      }
      this.getActividadesByCliente();
      this.drawerForm = true;
    },

    incluir() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.esRec = false;
      this.esExo = false;
      axios.get("api/Clientes/getCodigoCliente?cia=" + this.strCia).then(res => {
        this.editedItem.codigo = res.data;
      });
      this.drawerForm = true;
    },

    cerrar() {
      this.drawerForm = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.actividades = [];
        this.actividadDefecto = null;
      });
    },

    save() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      let me = this;
      this.editedItem.cia = this.strCia;
      this.editedItem.actividades = this.actividades;

      const url = this.editedIndex > -1 ? "api/Clientes/updateClientes" : "api/Clientes/insertClientes";
      axios.post(url, this.editedItem).then(() => {
        me.snackText = "Cliente guardado con éxito";
        me.snackValue = true;
        me.getData();
        me.cerrar();
      }).catch(err => {
        console.error(err);
        me.snackText = "Error al guardar el registro";
        me.snackValue = true;
      }).finally(() => { this.loading = false; });
    },

    deleteItem() {
      if (!confirm("¿Está seguro de que desea eliminar este cliente?")) return;
      let me = this;
      axios.get("api/Clientes/deleteCliente?cia=" + this.strCia + "&codigo=" + this.editedItem.codigo)
        .then(() => { me.getData(); me.cerrar(); })
        .catch(err => console.error(err));
    }
  },
};
</script>

<style scoped>
/* ===== CONTAINER ===== */
.cli-container {
  background-color: #f1f5f9;
  min-height: 100vh;
}
.theme--dark.cli-container {
  background-color: #0f172a;
}

/* ===== TOOLBAR ===== */
.cli-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.theme--dark .cli-toolbar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.07) !important;
}
.cli-toolbar-title {
  font-size: 0.95rem !important;
  letter-spacing: 1.5px;
}

/* ===== BUTTONS ===== */
.cli-btn {
  border-radius: 4px !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-size: 0.75rem !important;
}

/* ===== TABLE ===== */
.cli-table-card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}
.cli-table { background: transparent !important; }
.cli-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.07em;
  border-bottom: none !important;
}
.cli-table >>> tbody tr { cursor: pointer; }
.cli-table >>> tbody tr:hover {
  background-color: rgba(55, 71, 79, 0.05) !important;
}
.theme--dark .cli-table >>> tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* ===== CODE BADGE ===== */
.cli-code-badge {
  font-family: monospace;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 2px 6px;
  background: rgba(55, 71, 79, 0.08);
  border-radius: 3px;
  color: #37474f;
}
.theme--dark .cli-code-badge {
  background: rgba(255, 255, 255, 0.1);
  color: #b0bec5;
}

/* ===== SEARCH ===== */
.cli-search >>> .v-input__slot {
  border-radius: 4px !important;
}

/* ===== DRAWER ===== */
.cli-drawer >>> .v-navigation-drawer__content {
  background-color: #ffffff !important;
}
.theme--dark .cli-drawer >>> .v-navigation-drawer__content {
  background-color: #0f172a !important;
}

/* ===== DRAWER HEADER ===== */
.cli-drawer-header {
  background-color: #37474f;
  flex-shrink: 0;
}
.cli-drawer-header--dark {
  background-color: #263238 !important;
}

/* ===== DRAWER FOOTER ===== */
.cli-drawer-footer {
  background-color: #f8fafc;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}
.cli-drawer-footer--dark {
  background-color: #1e293b !important;
  border-top: 1px solid rgba(255, 255, 255, 0.07) !important;
}

/* ===== SECTION LABEL ===== */
.cli-section-label {
  display: flex;
  align-items: center;
}

/* ===== SECTION CARD ===== */
.cli-section-card {
  border: 1px solid rgba(0, 0, 0, 0.07) !important;
  border-radius: 4px !important;
  background-color: #ffffff !important;
}
.theme--dark .cli-section-card {
  border-color: rgba(255, 255, 255, 0.07) !important;
  background-color: #1e293b !important;
}

/* ===== READONLY INPUT ===== */
.cli-readonly-input >>> .v-input__slot {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.theme--dark .cli-readonly-input >>> .v-input__slot {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* ===== EXPANSION PANELS ===== */
.cli-panels {
  border: 1px solid rgba(0, 0, 0, 0.07) !important;
  border-radius: 4px !important;
  overflow: hidden;
}
.theme--dark .cli-panels {
  border-color: rgba(255, 255, 255, 0.07) !important;
}
.cli-expansion-panel {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}
.cli-expansion-panel:last-child {
  border-bottom: none !important;
}
.theme--dark .cli-expansion-panel {
  border-bottom-color: rgba(255, 255, 255, 0.05) !important;
}
.cli-panels >>> .v-expansion-panel {
  background-color: #ffffff !important;
}
.theme--dark .cli-panels >>> .v-expansion-panel {
  background-color: #1e293b !important;
}

/* ===== SIMPLE TABLE (actividades) ===== */
.cli-simple-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.7rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.07em;
}
</style>
